import axios from "axios";
import authService from "../../../Services/authService";

const API_KEY = "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";

// Utility: Compress Image before Base64 (optional)
const compressImage = (file, maxSize = 1024) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = () => {
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const scale = Math.min(maxSize / img.width, maxSize / img.height);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          file.type,
          0.7 // Quality
        );
      };
      img.onerror = reject;
      img.src = reader.result;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

// Convert image file to Base64
const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result;
      if (
        base64.startsWith("data:image/png") ||
        base64.startsWith("data:image/jpeg") ||
        base64.startsWith("data:image/webp") ||
        base64.startsWith("data:image/gif")
      ) {
        resolve(base64);
      } else {
        reject(new Error("Unsupported image type. Must be PNG, JPEG, GIF, or WEBP."));
      }
    };
    reader.onerror = (error) => reject(error);
  });
};

// Final export function for AI Analysis
export async function Aianalysis(file) {
  try {
    let imageUrl = "";

    // If file is a URL
    if (typeof file === "string" && file.startsWith("http")) {
      if (file.endsWith(".pdf")) {
        // Convert PDF to image using Laravel API
        const res = await fetch(authService.getApiUrl() + "reports-pdf-to-image", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ pdf_url: file }),
        });

        const data = await res.json();

        if (!data.success || !Array.isArray(data.images) || data.images.length === 0) {
          throw new Error(data.message || "PDF to image conversion failed.");
        }

        imageUrl = data.images[0]; // Use the first page of the PDF
      } else {
        imageUrl = file; // Direct image URL
      }
    }

    // If file is a File or Blob
    else if (file instanceof File || file instanceof Blob) {
      const compressed = file instanceof File ? await compressImage(file) : file;
      imageUrl = await convertImageToBase64(compressed);
    } else {
      throw new Error("Invalid input. Must be a File or a URL string.");
    }

    // Prepare request
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-4o",
        messages: [
          {
            role: "system",
            content:
              "You are a helpful medical assistant that extracts and interprets lab report details from images.",
          },
          {
            role: "user",
            content: [
              {
                type: "text",
                text: `
Analyze this lab report and provide the following in structured Markdown format:

1. **Summary**: Highlight key health parameters, abnormal findings, and their implications.
2. **Recommendations**: Suggest possible next steps, follow-up tests, or medical consultation if needed.

Use bullet points under each section. Be concise and medically accurate.
              `.trim(),
              },
              {
                type: "image_url",
                image_url: { url: imageUrl },
              },
            ],
          },
        ],
        max_tokens: 1000,
      },
      {
        headers: {
          Authorization: `Bearer ${API_KEY}`,
          "Content-Type": "application/json",
        },
        timeout: 20000, // 20 seconds
      }
    );

    // Check response validity
    if (
      !response?.data?.choices ||
      !response.data.choices[0]?.message?.content
    ) {
      throw new Error("Invalid or empty response from AI.");
    }

    return response.data;
  } catch (error) {
    console.error("AI Analysis Error:", error);
    return {
      error: true,
      message: error.message || "Unknown error during AI analysis",
    };
  }
}
